import { createContext, PropsWithChildren, useContext } from "react";

import { WorkPlanCapabilities } from "./WorkPlan.policy";

interface WorkPlanContextValue {
    capabilities: WorkPlanCapabilities;
}

const WorkPlanContext = createContext<WorkPlanContextValue | null>(null);

interface WorkPlanProviderProps extends PropsWithChildren {
    value: WorkPlanContextValue;
}

export const WorkPlanProvider = ({
    value,
    children,
}: WorkPlanProviderProps) => (
    <WorkPlanContext.Provider value={value}>
        {children}
    </WorkPlanContext.Provider>
);

export const useWorkPlan = () => {
    const context = useContext(WorkPlanContext);

    if (!context) {
        throw new Error("useWorkPlan must be used within WorkPlanProvider");
    }

    return context;
};
